// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2f0ae0b7","662":"8be86311","685":"24313dcf","862":"486ff813"}[chunkId] + ".chunk.js";
};